import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    console.log("PerPage controller connected")
  }

  change(event) {
    console.log("PerPage change event", event.target.value)
    const url = new URL(this.urlValue, window.location.origin)
    
    // Preserve all current URL parameters
    const currentParams = new URLSearchParams(window.location.search)
    for (const [key, value] of currentParams) {
      url.searchParams.set(key, value)
    }
    
    url.searchParams.set('per_page', event.target.value)
    url.searchParams.set('page', '1') // Reset to first page when changing items per page
    
    // Find the turbo frame we're in and target it
    const turboFrame = this.element.closest('turbo-frame')
    if (turboFrame) {
      turboFrame.src = url.toString()
    } else {
      Turbo.visit(url.toString(), { action: 'replace' })
    }
  }
}
